module.exports = __webpack_public_path__ + "img/Bloque-02.e79bf2c3.png";